import { Descriptions } from 'antd'
import React from 'react'
import { formatDOB } from '../../lib/datetime'
import { patientShape } from '../prop-types'
import { formatMedicalProvider } from '../Forms/MedicalProviderSelect'

export default function PatientSummary({ patient }) {
  const { medicalProvider } = patient

  return (
    <Descriptions column={3} size="small">
      <Descriptions.Item label="First Name">
        {patient.firstName}
      </Descriptions.Item>
      <Descriptions.Item label="Last Name">
        {patient.lastName}
      </Descriptions.Item>
      <Descriptions.Item label="Date of birth">
        {formatDOB(patient.birthDate)}
      </Descriptions.Item>
      <Descriptions.Item label="MRN">{patient.practiceMrn}</Descriptions.Item>
      <Descriptions.Item label="Medical provider">
        {formatMedicalProvider(medicalProvider)}
      </Descriptions.Item>
    </Descriptions>
  )
}

PatientSummary.propTypes = {
  patient: patientShape.isRequired,
}
